// extracted by css-extract-rspack-plugin
export default {"checkbox":"_11d2b809","stoneCutContainer":"_f08e297c","input":"_d852e88c"};